import React from 'react';

import { useRoverStatsigUser } from './hooks/useRoverStatsigUser';
import { useStatsigUserUpdates } from './hooks/useStatsigUserUpdates';
import { StatsigProvider, useClientAsyncInit } from './StatsigLib';
import { getStatsigConfig } from './utils';

export type Props = {
  children: React.ReactNode;
};

const RoverStatsigProvider = ({ children }: Props): JSX.Element => {
  const { roverStatsigUser } = useRoverStatsigUser();
  const { apiKey, clientOptions } = getStatsigConfig();

  // Initialize Statsig client asynchronously with the API key and any initial user data, from
  // https://docs.statsig.com/client/javascript-sdk/init-strategies/#3-asynchronous-initialization---not-awaited
  const { client } = useClientAsyncInit(apiKey, roverStatsigUser, clientOptions);

  useStatsigUserUpdates(client, roverStatsigUser);

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};

export default RoverStatsigProvider;
